import { cv } from "@suse-o11y/class-variance";
import React, { type FC } from "react";

import { Wrap } from "../../conditional-wrapper/Wrap";
import { Button } from "../buttons/Button";
import type { TooltipPlacement } from "../tooltip/BaseTooltip";
import { Tooltip } from "../tooltip/Tooltip";

const variants = cv(null, {
	variants: {
		size: {
			small: "h-[23px] px-1.5 text-[9px]/[23px]",
			middle: "px-2 text-xs/6",
		},
		disabled: {
			true: "pointer-events-none",
		},
	},
});

export declare type IconButtonSize = "small" | "middle";

export interface IconButtonProps {
	icon: React.ReactNode;
	onClick: () => void;
	tooltip?: string;
	tooltipPosition?: TooltipPlacement;
	disabled?: boolean;
	className?: string;
	size?: IconButtonSize;
}

export const IconButton: FC<IconButtonProps> = ({
	icon,
	onClick,
	tooltip,
	disabled,
	tooltipPosition = "top",
	size = "small",
	className,
	...props
}) => {
	return (
		<Wrap
			if={tooltip !== null}
			with={(wrappedChildren) => (
				<Tooltip placement={tooltipPosition} title={tooltip}>
					{/*** Tooltip does not disappear when button is disabled, needs workaround https://github.com/ant-design/ant-design/issues/9581*/}
					<span className="inline-flex cursor-not-allowed">{wrappedChildren}</span>
				</Tooltip>
			)}
		>
			<Button
				size={size}
				{...props}
				className={variants({ size, disabled, className })}
				disabled={disabled}
				onClick={() => {
					if (!disabled) {
						onClick();
					}
				}}
			>
				{icon}
			</Button>
		</Wrap>
	);
};
